import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Stack
} from "@mui/material";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import Input from "../../../../component/inputpm";
import { withTranslation } from "react-i18next";
import IconButton from "@mui/material/IconButton";
// import SearchIcon from "@mui/icons-material/Search";
// import ClearIcon from "@mui/icons-material/Clear";
import { Tooltip, TableContainer, TableHead, TableRow, MenuItem, Pagination, Table, TableBody, TableCell, Paper, Select } from "@mui/material";
import actionTypes from "../../../../store/actions";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import { PlusIcon } from "../../../../component/icons/icons.js";
import Loader from "../../../../component/loader/index.js";
import Draggable from "react-draggable";
import { formatNumber } from "../../../../helper/numberFormatter.js";
import { SearchIcon, ClearIcon } from "../../../../component/icons/icons.js";

const SearchUsersDialog = (props) => {
    const t = props.t;

    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    // unchanged state...
    const [showSearchLoader, setShowSearchLoader] = useState(false);
    const [totalUsersCount, setTotalUsersCount] = useState(0);
    const [userFilters, setUserFilters] = useState({
        firstName: "",
        lastName: "",
        userId: "",
        emailAddress: "",
    });
    const [userSearchResults, setUserSearchResults] = useState([]);

    // 🔍 call this without args; it reads current page/rowsPerPage
    const searchUsers = async (noFilter = false) => {
        setShowSearchLoader(true);

        const filters = noFilter
            ? { firstName: "", lastName: "", userId: "", emailAddress: "" }
            : userFilters;

        // zero-based pagination math
        const pageOptions = {
            batchSize: rowsPerPage,
            startRecord: rowsPerPage * (page - 1) + 1
        };

        try {
            const res = await BusApiCall(
                "GET",
                `${constants.busV4Url}/parties/ordop1/users?firstName=${filters.firstName}&lastName=${filters.lastName}&userId=${filters.userId}&emailAddress=${filters.emailAddress}`,
                {},
                pageOptions
            );
            setUserSearchResults(res.data.users);
            setTotalUsersCount(+res.headers["x-total-count"]);
        } catch (err) {
            if (err?.response?.data?.message) {
                props.setErrorMessage(err.response.data.message, false);
            } else {
                props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
            }
        } finally {
            setShowSearchLoader(false);
        }
    };

    // DO NOT call search here; state is async.
    // Let useEffect below react to the change.
    const changePage = (_e, newPage) => {
        setPage(newPage); // newPage is zero-based from MUI
    };

    const changeRowsPerPage = (e) => {
        const value = parseInt(e.target.value, 10);
        setRowsPerPage(value);
        setPage(1); // reset to first page
    };

    // Fetch whenever page/rowsPerPage change while dialog is open
    useEffect(() => {
        if (props.open) {
            searchUsers();
        }
    }, [page, rowsPerPage, props.open]);

    // Optional: Enter key triggers a fresh search on page 0
    const onSearchKeyDown = (e) => {
        if (e.key === "Enter") {
            setPage(1);
            searchUsers();
        }
    };

    // Optional: clear filters and refetch from page 0
    const clearUsersFilter = () => {
        setUserFilters({ firstName: "", lastName: "", userId: "", emailAddress: "" });
        setPage(1);
        searchUsers(true);
    };
    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            maxWidth="lg"
            fullWidth
            disableScrollLock
            PaperComponent={DraggableDialogPaper}
        >
            <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
                {/* {props.t('SEARCH')} */}
                {props.t('CREATED_BY')}
                <IconButton
                    onClick={props.onClose}
                    style={{ position: "absolute", right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers style={{ height: '500px' }}>
                <div>
                    <div className={'searchOuterDiv'}>
                        <div className={'searchInputDiv'}>
                            <Input
                                size={"small"}
                                variant={"outlined"}
                                placeholder={t("FIRST_NAME")}
                                value={userFilters.firstName}
                                name={"firstName"}
                                onChange={(e) => {
                                    setUserFilters({
                                        ...userFilters,
                                        [e.target.name]: e.target.value,
                                    });
                                }}
                                divClass={'inputClass'}
                                onKeyDown={(e) => {
                                    onSearchKeyDown(e);
                                }}
                            />
                        </div>
                        <div className={'searchInputDiv'}>
                            <Input
                                size={"small"}
                                variant={"outlined"}
                                placeholder={t("LAST_NAME")}
                                value={userFilters.lastName}
                                name={"lastName"}
                                onChange={(e) => {
                                    setUserFilters({
                                        ...userFilters,
                                        [e.target.name]: e.target.value,
                                    });
                                }}
                                divClass={'inputClass'}
                                onKeyDown={(e) => {
                                    onSearchKeyDown(e);
                                }}
                            />
                        </div>
                        <div className={'searchInputDiv'}>
                            <Input
                                size={"small"}
                                variant={"outlined"}
                                placeholder={t("USER_ID")}
                                value={userFilters.userId}
                                name={"userId"}
                                onChange={(e) => {
                                    setUserFilters({
                                        ...userFilters,
                                        [e.target.name]: e.target.value,
                                    });
                                }}
                                divClass={'inputClass'}
                                onKeyDown={(e) => {
                                    onSearchKeyDown(e);
                                }}
                            />
                        </div>
                        <div className={'searchInputDiv'}>
                            <Input
                                size={"small"}
                                variant={"outlined"}
                                placeholder={t("EMAIL")}
                                value={userFilters.emailAddress}
                                name={"emailAddress"}
                                onChange={(e) => {
                                    setUserFilters({
                                        ...userFilters,
                                        [e.target.name]: e.target.value,
                                    });
                                }}
                                divClass={'inputClass'}
                                onKeyDown={(e) => {
                                    onSearchKeyDown(e);
                                }}
                            />
                        </div>
                        <div className={'searchOrderLabelOuter'}>
                            <div className={'searchOrderLabelInner'}>
                                <Tooltip title={t("SEARCH")}>
                                    <IconButton
                                        className="iconButtonSecondary"
                                        onClick={searchUsers}
                                    // style={{ width: '31.44px', height: '31.44px' }}
                                    >
                                        <SearchIcon />
                                    </IconButton>
                                </Tooltip>{" "}
                                &nbsp;
                                <Tooltip title={t("CLEAR")}>
                                    <IconButton
                                        className="iconButtonSecondary"
                                        onClick={clearUsersFilter}
                                    // style={{ width: '31.44px', height: '31.44px' }}
                                    >
                                        <ClearIcon />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </div>
                <Box
                    className="roundCorners"
                    style={{
                        border: "1px solid lightgrey",
                        // marginTop: "1rem",
                    }}
                >
                    <TableContainer>
                        <Table
                            className="newGlobalTable"
                            aria-label="simple table"
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell>{props.t('FIRST_NAME')}</TableCell>
                                    <TableCell>{props.t('LAST_NAME')}</TableCell>
                                    <TableCell>{props.t('USER_ID')}</TableCell>
                                    <TableCell>{props.t('EMAIL')}</TableCell>
                                    <TableCell>{props.t('ACTION')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {userSearchResults && userSearchResults.length > 0 && userSearchResults.map((row, index) =>
                                    <TableRow key={index}>
                                        <TableCell>{row.firstName}</TableCell>
                                        <TableCell>{row.lastName}</TableCell>
                                        <TableCell>{row.userId}</TableCell>
                                        <TableCell>{row.emailAddress}</TableCell>
                                        <TableCell>
                                            <Tooltip title={t("SELECT")}>
                                                {props.screen === 'add' ?
                                                    <IconButton
                                                        className="iconButtonSecondary"
                                                        onClick={props.selectUser(row)}
                                                        style={{ width: '31.44px', height: '31.44px' }}
                                                    >
                                                        <PlusIcon />
                                                    </IconButton>
                                                    :
                                                    <IconButton
                                                        className="iconButtonSecondary"
                                                        onClick={() => props.selectUser(row)}
                                                        style={{ width: '31.44px', height: '31.44px' }}
                                                    >
                                                        <PlusIcon />
                                                    </IconButton>
                                                }
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {totalUsersCount > 0 && (
                        <div
                            className="global-custom-pagination"
                            style={{ background: "rgba(196, 196, 196, 0.2)" }}
                        >
                            <label style={{ float: "left", padding: "5px" }}>
                                {t("TOTAL_RECORDS")}: {formatNumber(totalUsersCount)}
                            </label>
                            <label>
                                {/* Rows per page select */}
                                {t("ROWS_PER_PAGE")}
                                <Select
                                    value={rowsPerPage}
                                    onChange={changeRowsPerPage}
                                >
                                    <MenuItem
                                        value={10}
                                        classes={{ root: "treeRowPerPageItem" }}
                                    >
                                        10
                                    </MenuItem>
                                    <MenuItem
                                        value={50}
                                        classes={{ root: "treeRowPerPageItem" }}
                                    >
                                        50
                                    </MenuItem>
                                    <MenuItem
                                        value={100}
                                        classes={{ root: "treeRowPerPageItem" }}
                                    >
                                        100
                                    </MenuItem>
                                </Select>
                            </label>
                            {/* Pagination component */}
                            <Pagination
                                page={page}
                                count={Math.ceil(
                                    totalUsersCount /
                                    rowsPerPage,
                                )}
                                onChange={changePage}
                                showFirstButton
                                showLastButton
                            />
                        </div>
                    )}
                </Box>
            </DialogContent>
            <Loader loading={showSearchLoader} />
        </Dialog>
    )
}

const DraggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            bounds={"parent"}
            defaultClassName="customReactDraggableComponent"
            handle="#draggableDialogPaper"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
};

// Fetch data from redux store
const mapStateToProps = (state) => {
    return {
        tenantData: state.auth.tenantData,
        loggedInUserType: state.auth.userLoginType,
        countriesList: state.global.countriesList,
        defaultCountry: state.auth.defaultCountry,
        loggedInUserId: state.auth.loggedInUserId,
        showMyCustomers: state.auth.showMyCustomers,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setErrorMessage: (errMsg, msgType) =>
            dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withTranslation("translations")(SearchUsersDialog));
